import { Checkbox } from '@chakra-ui/checkbox'
import { IoIosArrowDown } from 'react-icons/io'

import { Box, Text } from '@chakra-ui/layout'
import { Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverTrigger } from '@chakra-ui/popover'
import { AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay } from '@chakra-ui/react'
import { Portal } from '@chakra-ui/portal'
import { Icon, useDisclosure } from '@chakra-ui/react'
import { Button as InnovationButton } from '../Button'
import React, { useEffect } from 'react'
import { Button } from '../Button'

export function DropdownCheckbox({ label, options, onConfirm, isReadOnly, ...props }) {
    const { onOpen, onClose, isOpen } = useDisclosure()

    const initialDefaultChecked = options?.find((item) => item.value === props.defaultValue)

    const [value, setValueInternal] = React.useState(null)
    const [alertOpen, setAlertOpen] = React.useState(false)
    const [changeConfirmed, setChangeConfirmed] = React.useState(false)
    const [openedFirstTime, setOpenedFirstTime] = React.useState(false)

    useEffect(() => {
        setValueInternal(initialDefaultChecked)
    }, [initialDefaultChecked])

    const handleChange = (item) => {
        setValueInternal(item.value === value ? null : item)
    }

    useEffect(() => {
        if (!props.isLoading && props.close) {
            onClose()
        }
    }, [props.isLoading, onClose, props.close])

    //se o cara sair sem confirmar, o valor volta ao valor inicial
    useEffect(() => {
        if (!isOpen) {
            setValueInternal(initialDefaultChecked)
        }
    }, [isOpen, initialDefaultChecked])

    const handleConfirm = () => {
        onConfirm({ value })
        setChangeConfirmed(true)
        onClose()
    }

    //quando clicar fora, avisar que o cara saiu sem confirmar
    useEffect(() => {
        if (!isOpen) {
            setValueInternal(initialDefaultChecked)
            if (openedFirstTime && !changeConfirmed && value !== initialDefaultChecked) {
                setAlertOpen(true)
            }
        }
    }, [isOpen, initialDefaultChecked, value, changeConfirmed, openedFirstTime])

    return (
        <Popover
            autoFocus
            isOpen={isOpen}
            // onClose={props.isLoading ? () => {} : onCloseWithAlert}
            //closee quando o cara clicar fora
            closeOnBlur={false}
        >
            <AlertDialogCustom
                isOpen={alertOpen}
                onClose={onClose}
                alertClose={() => {
                    setAlertOpen(false)
                }}
                handleConfirm={() => {
                    handleConfirm()
                    setAlertOpen(false)
                }}
            />
            <PopoverTrigger>
                <Box
                    bg="#EDF2F7"
                    {...(isOpen && {
                        bgColor: '#378BBF',

                        color: 'white',

                        _hover: { bgColor: '#378BBF' },
                    })}
                    opacity={isReadOnly ? "0.5" : "1"}
                    onClick={isReadOnly ? undefined : onOpen}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    cursor={!isReadOnly ? "pointer" : "auto"}
                    maxW={props.maxW ? props.maxW : '205px'}
                    {...props}
                >
                    <Text as="strong" w="fit-content" whiteSpace="nowrap" mr={2}>
                        {label}:
                    </Text>
                    {value?.label && (
                        <Text maxW="100%" isTruncated as="span" textTransform="capitalize">
                            {value?.label}
                        </Text>
                    )}
                    {
                        !isReadOnly && (
                            <Icon as={IoIosArrowDown} ml="auto" transition="transform 0.3s" transform={isOpen ? 'rotate(180deg)' : 'rotate(0)'} />
                        )
                    }
                </Box>
            </PopoverTrigger>

            <Portal>
                <PopoverContent>
                    <PopoverArrow />

                    <PopoverCloseButton
                        onClick={() => {
                            setAlertOpen(true)
                        }}
                    />

                    <PopoverBody>
                        {/* create checkbox and label */}

                        {options?.map((item) => (
                            <CheckboxItem key={item.value} item={item} value={value} onChange={handleChange} />
                        ))}
                    </PopoverBody>

                    <InnovationButton maxW="181px" w="100%" mx="auto" mb={3} isLoading={props.isLoading} onClick={handleConfirm}>
                        Confirmar
                    </InnovationButton>
                </PopoverContent>
            </Portal>
        </Popover>
    )
}
function CheckboxItem({ item, value, onChange }) {
    return (
        <Box display="flex" alignItems="center" gap={5} h="37px" px={2} fontWeight="bold" fontSize="12px" borderBottom={'1px solid #DBDBDB'} pb={3} mb={3}>
            <Checkbox id={item.id} size="lg" borderColor="#378BBF" borderRadius={0} isChecked={value === item} onChange={() => onChange(item)} />
            <Text as={'label'} htmlFor={item.id} color="#1D1D1D" fontSize="12px" fontWeight="normal">
                {item.label}
            </Text>
        </Box>
    )
}

function AlertDialogCustom({ isOpen, onClose, alertClose, handleConfirm }) {
    const cancelRef = React.useRef()

    function handleClose() {
        onClose()
        alertClose()
    }

    return (
        <>
            <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            Você está saindo sem confirmar a alteração
                        </AlertDialogHeader>

                        <AlertDialogBody>Você tem certeza que deseja sair sem confirmar a alteração?</AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={handleClose}>
                                Sair
                            </Button>
                            <Button onClick={handleConfirm} ml={3}>
                                Confirmar a alteração e sair
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    )
}
